import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const BasketContext = createContext(null);
export const useBasket = () => useContext(BasketContext);

const KEY = "nabor_basket";

export function BasketProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) => (i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: (product.images || [])[0] || "", seller_id: product.seller_id,
        seller_name: product.seller_name, quantity: qty,
      }];
    });
    toast.success(`${product.name} added to basket`);
  };
  const updateQty = (product_id, quantity) => {
    if (quantity < 1) return remove(product_id);
    setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, quantity } : i)));
  };
  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const sellerCount = new Set(items.map((i) => i.seller_id)).size;

  return (
    <BasketContext.Provider value={{ items, add, updateQty, remove, clear, count, subtotal, sellerCount }}>
      {children}
    </BasketContext.Provider>
  );
}
